export const isNil = (value: any): boolean => {
  return value === null || value === undefined
}
export const isEmptyString = (value: any): boolean => {
  return value === null || value === undefined || value === ''
}
export const isEmptyEmail = (value: any): boolean => {
  return value === null || value === undefined || value === '' || (value as string).includes('nomail@nomail')
}

export const checkLen = (value: any, length: number): boolean => {
  return value.length === (length ?? 0)
}
